import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getDeviceList, getDeviceInfo, getCameraList } from '@/service/ys7';

const defaultState = {
  fetching: false,
  error: null,
  query: {},
  // 设备列表
  deviceList: {
    data: [],
    query: {}
  },
  // 设备信息
  deviceInfo: {
    data: {},
    query: {}
  },
  // 摄像头列表
  cameraList: {
    data: [],
    query: {}
  }
};

// 获取设备列表
export const fetchDeviceList = createAsyncThunk(
  'ys7Device/fetchDeviceList',
  async (body = {}, { rejectWithValue }) => {
    try {
      const response = await getDeviceList(body);
      return {
        data: response?.data,
        query: body
      };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message || '获取设备列表失败');
    }
  }
);

// 获取设备信息
export const fetchDeviceInfo = createAsyncThunk(
  'ys7Device/fetchDeviceInfo',
  async (body = {}, { rejectWithValue }) => {
    try {
      const response = await getDeviceInfo(body);
      return {
        data: response?.data,
        query: body
      };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message || '获取设备信息失败');
    }
  }
);

// 获取摄像头列表
export const fetchCameraList = createAsyncThunk(
  'ys7Device/fetchCameraList',
  async (body = {}, { rejectWithValue }) => {
    try {
      const response = await getCameraList(body);
      return {
        data: response?.data,
        query: body
      };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message || '获取摄像头列表失败');
    }
  }
);

const deviceSlice = createSlice({
  name: 'ys7Device',
  initialState: defaultState,
  reducers: {
    resetDeviceState: () => defaultState
  },
  extraReducers: (builder) => {
    builder
      // fetchDeviceList
      .addCase(fetchDeviceList.pending, (state, action) => {
        state.fetching = true;
        state.error = null;
        state.deviceList.query = action.meta.arg || {};
      })
      .addCase(fetchDeviceList.fulfilled, (state, action) => {
        state.fetching = false;
        state.error = null;
        state.deviceList.data = action.payload?.data?.data || action.payload?.data || [];
        state.deviceList.query = action.payload?.query || {};
      })
      .addCase(fetchDeviceList.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload;
        state.deviceList.data = [];
      })

      // fetchDeviceInfo
      .addCase(fetchDeviceInfo.pending, (state, action) => {

        state.fetching = true;
        state.error = null;
        state.deviceInfo.query = action.meta.arg || {};
      })
      .addCase(fetchDeviceInfo.fulfilled, (state, action) => {
        state.fetching = false;
        state.error = null;
        state.deviceInfo.data = action.payload?.data?.data || action.payload?.data || {};
        state.deviceInfo.query = action.payload?.query || {};
      })
      .addCase(fetchDeviceInfo.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload;
        state.deviceInfo.data = {};
      })

      // fetchCameraList
      .addCase(fetchCameraList.pending, (state, action) => {
        state.fetching = true;
        state.error = null;
        state.cameraList.query = action.meta.arg || {};
      })
      .addCase(fetchCameraList.fulfilled, (state, action) => {
        state.fetching = false;
        state.error = null;
        state.cameraList.data = action.payload?.data?.data || action.payload?.data || [];
        state.cameraList.query = action.payload?.query || {};
      })
      .addCase(fetchCameraList.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload;
        state.cameraList.data = [];
      });
  }
});

export const { resetDeviceState } = deviceSlice.actions;
export default deviceSlice.reducer;
